import {getCsrfToken} from "../../plugins/get-csrf-token";
import Swal from "sweetalert2";
import makeId from "../../libs/make-id";

export default function ($context) {
    if (!$context.length) {
        return;
    }

    $context.on('click', '.showVideoPlayer', function (event) {
        event.preventDefault();

        const $componentChangeVideo = $(this).closest('.cloud-component-change-video-image');
        const cloudModalId = $componentChangeVideo.data('cloud-player-modal-id');
        const $cloudModal = $(document.getElementById(cloudModalId));
        const cloudPlayerModalContentUrl = $componentChangeVideo.data('cloud-player-modal-content-url');
        const cloudFileInputId = $componentChangeVideo.data('cloud-input-id');
        const cloudFileId = $(document.getElementById(cloudFileInputId)).val();

        $cloudModal
            .modal('show')
            .css('z-index', 1041)
            .find('.modal-content')
            .html('<div class="m-5 text-center">' +
                '<div class="spinner-border mb-3" role="status"></div>' +
                '<strong class="d-block">Loading data, please wait...</strong>' +
                '</div>')
            .load(cloudPlayerModalContentUrl + '/' + cloudFileId, function (responseText, textStatus) {
                if ('error' === textStatus) {
                    return $(this).html(responseText);
                }
            });
    });

    $context.on('click', '.takeScreenshot', function (event) {
        event.preventDefault();

        const $takeScreenshotButton = $(this);
        const cloudDivId = $(this).closest('.modal').data('cloud-div-id');
        const cloudFileId = $(this).data('cloud-file-id');
        const cloudFileScreenshotUrl = $(this).data('cloud-file-screenshot-url');
        const video = document.getElementById("video-" + cloudFileId);

        video.pause();

        $.ajax({
            type: "POST",
            headers: {'X-CSRF-TOKEN': getCsrfToken()},
            url: cloudFileScreenshotUrl,
            data: {
                'cloud_file_id': cloudFileId,
                'time': video.currentTime,
            },
            success: function (imageNewSrc) {
                $takeScreenshotButton.closest('.modal').modal('hide');
                const image = $context.find("#" + cloudDivId + ' .cloud-component-image');
                image.removeAttr('src').attr('src', imageNewSrc + '?' + makeId(8));
            },
            error: function (xhr, status, error) {
                Swal.fire({
                    type: 'error',
                    title: 'Error',
                    text: error.message,
                });
            },
        });
    });

    $context.on('change', '.uploadVideoThumbnail input', function (event) {
        event.preventDefault();

        const $componentChangeVideo = $(this).closest('.cloud-component-change-video-image');
        const uploadVideoThumbnailUrl = $componentChangeVideo.data('cloud-upload-video-thumbnail-url');
        const cloudFileInputId = $componentChangeVideo.data('cloud-input-id');
        const cloudFileId = $(document.getElementById(cloudFileInputId)).val();

        const formData = new FormData();
        formData.append('file', $(this)[0].files[0]);
        formData.append('cloud_file_id', cloudFileId);

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': getCsrfToken()},
            url: uploadVideoThumbnailUrl,
            data: formData,
            contentType: false,
            processData: false,
            success: function(){
                const cloudDivId = $componentChangeVideo.data('cloud-div-id');
                const image = $context.find("#" + cloudDivId + ' .cloud-component-image');
                const imageSrc = image.attr('src');
                const imageNewSrc = imageSrc + '?' + makeId(8);
                image.removeAttr('src').attr('src', imageNewSrc);
            },
            error: function (xhr, status, error) {
                Swal.fire({
                    type: 'error',
                    title: 'Error',
                    text: error.message,
                });
            },
        });
    });

    $context.on('click', '.selectVideoThumbnailFromCloud', function (event) {
        event.preventDefault();

        const $componentChangeVideo = $(this).closest('.cloud-component-change-video-image');
        const cloudModalId = $componentChangeVideo.data('cloud-player-modal-id');
        const $cloudModal = $(document.getElementById(cloudModalId));
        const cloudFilesListUrl = $componentChangeVideo.data('cloud-files-list-url');
        const cloudFileInputId = $componentChangeVideo.data('cloud-input-id');
        const cloudFileId = $(document.getElementById(cloudFileInputId)).val();

        $cloudModal
            .modal('show')
            .css('z-index', 1041)
            .find('.modal-content')
            .html('<div class="m-5 text-center">' +
                '<div class="spinner-border mb-3" role="status"></div>' +
                '<strong class="d-block">Loading data, please wait...</strong>' +
                '</div>')
            .load(cloudFilesListUrl + '/' + cloudFileId, function (responseText, textStatus) {
                if ('error' === textStatus) {
                    return $(this).html(responseText);
                }
            });
    });

    $context.on('click', ".setVideoThumbnail", function (event) {
        event.preventDefault();

        const cloudSelectVideoThumbnailUrl = $(this).data('cloud-select-video-thumbnail-url');
        const cloudSelectedFileId = $(this).data('cloud-file-id');
        const cloudVideoFileId = $(this).data('cloud-video-file-id');
        const cloudDivId = $(this).closest('.modal').data('cloud-div-id');
        const imageSrc = $(this).data('image-url');

        $.ajax({
            type: "POST",
            headers: {'X-CSRF-TOKEN': getCsrfToken()},
            url: cloudSelectVideoThumbnailUrl,
            data: {
                'cloud_video_id': cloudVideoFileId,
                'cloud_selected_id': cloudSelectedFileId,
            },
            success: function () {
                const image = $context.find("#" + cloudDivId + ' .cloud-component-image');

                image.removeAttr('src').attr('src', imageSrc);
            },
            error: function (xhr, status, error) {
                Swal.fire({
                    type: 'error',
                    title: 'Error',
                    text: error.message,
                });
            },
        });
    });
}
